import React from "react";
import PropTypes from "prop-types";
import ColorSkinWrapper from "../../../common/colorSkinWrapper";
import Svg from "../../../common/svgIcon";
import SkybetLogo from "./SkyBetLogo";
import "./styles.scss";
import BetfredLogo from "./BetfredLogo";
import { bookmakerNames } from "../../../common/utils/constants/bookmakers";

const BookmakerLogo = ({ bookmakerName }) => {
	switch (bookmakerName) {
		case bookmakerNames.skybet:
			return <SkybetLogo />;
		case bookmakerNames.betfred:
			return <BetfredLogo />;
		default:
			return <Svg iconName={bookmakerName} size="8XL" />;
	}
}

const SelectionInfoModal = ({
	bookmakerName,
	bookmakerDisplayName,
	previouslySelectedBookie,
	hideSelectionInfoModal,
}) => (
	<ColorSkinWrapper
		bookmakerName={bookmakerName}
		className={`bs-selectionInfoModal
                    bs-switchBookmakers__modal`}
	>
		<span onClick={hideSelectionInfoModal}>
			<Svg iconName='close' size='regular' />
		</span>
		<h4>Odds displayed on Racing Post have been changed to:</h4>
		<BookmakerLogo bookmakerName={bookmakerName} />
		<p>
			<span>{bookmakerDisplayName}</span> odds will show on all racecards and be the default
			odds in the betslip.
		</p>
		{previouslySelectedBookie && (
			<p>(You were previously viewing {previouslySelectedBookie})</p>
		)}
	</ColorSkinWrapper>
);

SelectionInfoModal.propTypes = {
	bookmakerName: PropTypes.string.isRequired,
	bookmakerDisplayName: PropTypes.string.isRequired,
	previouslySelectedBookie: PropTypes.string,
	hideSelectionInfoModal: PropTypes.func,
};

export default SelectionInfoModal;



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/chooseBookmakerPage/components/SelectionInfoModal.jsx